import {Configure, InstantSearch} from 'react-instantsearch-hooks-web'
import Filter from './Filter'
import Header from './Header'
import {getSearchClient, indexName} from './helpers/algoliasearch'
import {useCookies} from 'react-cookie'
import {useEffect, useState} from 'react'
import Footer from './Footer'
import InvalidApplicantID from './InvalidApplicantID'
const searchClient = getSearchClient()

function App() {
	const [, setCookie] = useCookies(['ref_code'])
	const [isValidApplicantID, setValidApplicantID] = useState(false)
	useEffect(() => {
		const queryParams = new URLSearchParams(window.location.search)
		const ref_code = queryParams.get('ref')
		const applicantID = queryParams.get('applicantID')
		if (applicantID) {
			setValidApplicantID(true)
		}
		if (ref_code !== null)
			setCookie('ref_code', ref_code, {path: '/', maxAge: 86400})
		const {origin, pathname} = window.location
		if (queryParams.has('ref')) window.location.replace(origin + pathname)
	}, [setCookie])

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				minHeight: '100vh',
			}}
		>
			{isValidApplicantID ? (
				<>
					<Header />
					<main style={{flex: '1'}}>
						<InstantSearch
							searchClient={searchClient}
							indexName={indexName}
						>
							{/* <Configure /> */}
							<Configure filters={`recordType:"Intern"`} />
							<Filter />
						</InstantSearch>
					</main>
					<Footer />
				</>
			) : (
				<InvalidApplicantID />
			)}
		</div>
	)
}

export default App
